export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/**
 * Compute a default from/to range ending yesterday (the latest day with
 * metrics available) and extending `days` back.
 */
export function defaultRange(days = 30): { from: string; to: string } {
  const end = new Date();
  end.setUTCDate(end.getUTCDate() - 1);
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - days);
  return { from: toIso(start), to: toIso(end) };
}

export function toIso(date: Date): string {
  return date.toISOString().split('T')[0];
}
